// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3PUsd","content":"styles_content__7u7rn","checkbox":"styles_checkbox__3tLOl","checkboxLabel":"styles_checkboxLabel__1XTS9"};